/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipBackIcon20Solid = forwardRef('MediaUiASkipBackIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M14.7 2.948 5.517 8.73c-.227.143-.4.332-.516.544V4a1 1 0 1 0-2 0v12a1 1 0 1 0 2 0v-5.275c.117.212.289.401.516.544l9.185 5.783A1.5 1.5 0 0 0 17 15.783V4.217a1.5 1.5 0 0 0-2.3-1.27Z" })));
});
